import { handleActions } from 'redux-actions';
import { setSnapshotReadOnly } from 'store/actions/trial-balance/trial-balance-snapshot-view-action';
import { resetSideBySideViewMode } from 'store/actions/side-by-side-view-annotations-actions';

const DEFAULT = false;

export default handleActions(
  {
    [setSnapshotReadOnly]: (_, { payload }) => {
      return payload;
    },
    [resetSideBySideViewMode]: () => {
      return DEFAULT;
    },
  },
  DEFAULT,
);
